import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../redux/connect';
import {
  fetchIssuesAction,
  fetchIssueInstanceAction,
  setPreviewIssueIdAction,
  showNewIssueModalAction,
  routeChangeEventTriggerAction,
  setCurrentViewAction,
  fetchCurrentUserAction,
  fetchCurrentDocsProjectAction,
  setAnalyticsId,
  registerAnalyticsMandatorySuperProps,
  setAnalyticsPeopleProps,
  setAnalyticsMandatoryPeopleProps,
  setQueryParamsFromUrlAction,
  setPackageDeepLinkingFalse,
} from '../../../redux/actions';
import {
  getCurrentViewType,
  getCurrentUser,
  isLoadingCurrentUser,
  getOxygenMappings,
  getCurrentProject,
  getProjectsLength,
  getRegion,
  getAnalyticsId,
  getAnalyticsHostingAppName,
  getIsPackageDeepLinking,
} from '../../../redux/selectors';
import { Route, Router, Switch } from 'react-router-dom';
import PathNotFound from '../../../scenes/PathNotFound';
import ProjectGrid from '../../../scenes/ProjectGrid';
import IssueNew from '../../../scenes/IssueNew';
import IssuePreviewPanel from '../../../scenes/IssuePreviewPanel';
import RFIsAdmin from '../../../scenes/RFIsAdmin';
import ComponentRouteWrapper from './components/ComponentRouteWrapper';
import IssuesPanel from '../../../scenes/IssuesPanel';
import { historyAttributesType, userType } from '../../../constants/proptype-validation';
import { viewTypes } from '../../../constants/view-types';
import { peoplePropsFieldsMapping } from '../../../constants/analytics';
import lodashGet from 'lodash/get';
import { getAnalyticsMandatoryPeopleProps, registerAnalyticsSuperPropsHelper } from '../../../utils/analytics-helpers';
import { getIssuesUIQueryParamsFromUrl, getLocationObjectFromUrl } from '../../../utils/query-helpers';

class Routes extends PureComponent {
  constructor() {
    super(...arguments);

    this.state = {
      didFetchFieldIssuesMetadata: false,
    };

    /*
     * Routes are defined, here, because react-router routes must be immutable -- they cannot re-render in response to
     * changing props.  (otherwise, the following error is thrown: "You cannot change <Router routes>; it will be ignored")
    */

    this.routes = this.getRoutes();

    this.setPackageDeepLinkingFalse = this.setPackageDeepLinkingFalse.bind(this);
    this.handleBrowserNavigate = this.handleBrowserNavigate.bind(this);
    this.setQueryParamsFromRoutes = this.setQueryParamsFromRoutes.bind(this);
    this.handleOnEnterProjectView = this.handleOnEnterProjectView.bind(this);
    this.handleOnEnterPreviewIssue = this.handleOnEnterPreviewIssue.bind(this);
    this.handleOnLeaveProjectView = this.handleOnLeaveProjectView.bind(this);
    this.resetPreviewId = this.resetPreviewId.bind(this);
    this.handleOnEnterDocumentView = this.handleOnEnterDocumentView.bind(this);
  }

  componentWillMount() {
    const { setAnalyticsId, registerAnalyticsMandatorySuperProps, fetchCurrentDocsProjectAction, currentProject, region, analyticsId, analyticsHostingAppName, isLoadingCurrentUser } = this.props;

    setAnalyticsId(analyticsId);
    registerAnalyticsMandatorySuperProps(registerAnalyticsSuperPropsHelper(currentProject, region, analyticsHostingAppName));
    fetchCurrentDocsProjectAction();
    if (!isLoadingCurrentUser) {
      this.analyticsPeopleSetup(this.props);
    }

    window.addEventListener('popstate', this.handleBrowserNavigate);
  }

  componentDidMount() {
    window.addEventListener('click', this.setPackageDeepLinkingFalse);
    window.addEventListener('keydown', this.setPackageDeepLinkingFalse);
    window.addEventListener('touchstart', this.setPackageDeepLinkingFalse);
    this.deepLinkingHandlersAttached = true;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isLoadingCurrentUser && !nextProps.isLoadingCurrentUser) {
      this.analyticsPeopleSetup(nextProps);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handleBrowserNavigate);
    this.removeDeepLinkingEventListeners();
  }

  setPackageDeepLinkingFalse() {
    this.props.setPackageDeepLinkingFalse();
    this.removeDeepLinkingEventListeners();
  }

  removeDeepLinkingEventListeners() {
    if (this.deepLinkingHandlersAttached) {
      window.removeEventListener('click', this.setPackageDeepLinkingFalse);
      window.removeEventListener('keydown', this.setPackageDeepLinkingFalse);
      window.removeEventListener('touchstart', this.setPackageDeepLinkingFalse);
      this.deepLinkingHandlersAttached = false;
    }
  }

  setQueryParamsFromRoutes(currentView = this.props.currentView) {
    this.props.setQueryParamsFromUrlAction(getIssuesUIQueryParamsFromUrl(), currentView, getLocationObjectFromUrl());
  }

  handleBrowserNavigate() {
    this.setQueryParamsFromRoutes();
  }

  analyticsPeopleSetup(props) {
    const { oxygenMappings, projectsLength } = this.props;

    if (lodashGet(props.currentUser, 'attributes.id')) {
      const user = oxygenMappings.users[props.currentUser.attributes.id];
      this.props.setAnalyticsMandatoryPeopleProps(getAnalyticsMandatoryPeopleProps(user));
      this.props.setAnalyticsPeopleProps({ nonSensitive: { [peoplePropsFieldsMapping.NUM_OF_PROJECTS]: projectsLength } });

    }
  }

  fetchIssueById(id) {
    const { fetchIssueInstanceAction, isPackageDeepLinking } = this.props;

    fetchIssueInstanceAction(id, isPackageDeepLinking);
  }

  handleOnEnterDocumentView() {
    const currentView = viewTypes.DOCUMENT;

    // Prevent setting view type if it didn't change (happens when switching between issue types in the same view)
    if (this.props.currentView !== currentView) {
      this.props.setCurrentViewAction(currentView);
    }

    this.setQueryParamsFromRoutes(currentView);

    this.props.fetchIssuesAction();

    if (!this.props.currentUser.attributes) {
      this.props.fetchCurrentUserAction();
    }
  }

  handleOnEnterProjectView(match) {
    const currentView = viewTypes.PROJECT;

    // Prevent setting view type if it didn't change (happens when switching between issue types in the same view)
    if (this.props.currentView !== currentView) {
      this.props.setCurrentViewAction(currentView);
    }

    this.setQueryParamsFromRoutes(currentView);

    if (!this.props.currentUser.attributes) {
      this.props.fetchCurrentUserAction();
    }
    if (match.params.id) {
      if (match.params.id === 'new') {
        this.showNewIssueModal();
      } else {
        this.handleOnEnterPreviewIssue(match);
      }
    }
  }

  handleOnLeaveProjectView({ params }) {
    const { id } = params;
    if (id) {
      if (id === 'new') {
        this.hideNewIssueModal();
      } else {
        this.resetPreviewId(id);
      }
    }
  }

  handleOnEnterPreviewIssue(match) {
    const { setPreviewIssueIdAction } = this.props;
    const { params: { id } } = match;

    setPreviewIssueIdAction(id);
    this.fetchIssueById(id);
    if (!this.props.currentUser.attributes) {
      this.props.fetchCurrentUserAction();
    }
  }

  resetPreviewId() {
    const { setPreviewIssueIdAction } = this.props;
    setPreviewIssueIdAction(null);
  }

  showNewIssueModal() {
    this.toggleNewIssueModal(true);
  }

  hideNewIssueModal() {
    this.toggleNewIssueModal(false);
  }

  toggleNewIssueModal(visible) {
    const { showNewIssueModalAction } = this.props;
    showNewIssueModalAction(visible);
  }

  getRoutes() {
    const { history } = this.props;
    return (
      <Router history={history}>
        <Switch>
          <Route path="/project/rfis/:id?" render={(routerProps) => (
            <ComponentRouteWrapper {...this.props} {...routerProps} onEnter={this.handleOnEnterProjectView}
              onLeave={this.handleOnLeaveProjectView}
              Component={ProjectGrid}
            />
          )}
          />
          <Route path="/rfis/new" render={(routerProps) => (
            <ComponentRouteWrapper {...this.props} {...routerProps}
              Component={IssueNew}
            />
          )}
          />
          <Route path="/rfis/:id" render={(routerProps) => (
            <ComponentRouteWrapper {...this.props} {...routerProps}
              onEnter={this.handleOnEnterPreviewIssue}
              onLeave={this.resetPreviewId}
              Component={IssuePreviewPanel}
            />
          )}
          />

          <Route path="/rfis" render={(routerProps) => (
            <ComponentRouteWrapper {...this.props} {...routerProps}
              onEnter={this.handleOnEnterDocumentView}
              Component={IssuesPanel}
            />
          )}
          />
          <Route path="/admin" render={(routerProps) => (
            <ComponentRouteWrapper {...this.props} {...routerProps}
              Component={RFIsAdmin}
            />
          )}
          />
          <Route path="*" render={(routerProps) => (
            <ComponentRouteWrapper {...this.props} {...routerProps} params={routerProps.match.params}
              Component={PathNotFound}
            />
          )}
          />
        </Switch>
      </Router>
    );
  }

  render() {
    return this.routes;
  }
}

Routes.propTypes = {
  history: historyAttributesType.isRequired,
  routeChangeEventTriggerAction: PropTypes.func.isRequired,
  fetchIssuesAction: PropTypes.func.isRequired,
  fetchIssueInstanceAction: PropTypes.func.isRequired,
  fetchCurrentDocsProjectAction: PropTypes.func.isRequired,
  setPreviewIssueIdAction: PropTypes.func.isRequired,
  showNewIssueModalAction: PropTypes.func.isRequired,
  setCurrentViewAction: PropTypes.func.isRequired,
  currentView: PropTypes.string,
  fetchCurrentUserAction: PropTypes.func.isRequired,
  currentUser: userType,
  isLoadingCurrentUser: PropTypes.bool.isRequired,
  setAnalyticsId: PropTypes.func.isRequired,
  registerAnalyticsMandatorySuperProps: PropTypes.func,
  setAnalyticsPeopleProps: PropTypes.func,
  setAnalyticsMandatoryPeopleProps: PropTypes.func,
  setQueryParamsFromUrlAction: PropTypes.func.isRequired,
  currentProject: PropTypes.object,
  projectsLength: PropTypes.number,
  region: PropTypes.string,
  analyticsId: PropTypes.string,
  analyticsHostingAppName: PropTypes.string,
  oxygenMappings: PropTypes.object,
  setPackageDeepLinkingFalse: PropTypes.func.isRequired,
  isPackageDeepLinking: PropTypes.bool.isRequired,
};

Routes.displayName = 'Routes';

const mapStateToProps = (state) => ({
  currentView: getCurrentViewType(state),
  currentUser: getCurrentUser(state),
  isLoadingCurrentUser: isLoadingCurrentUser(state),
  currentProject: getCurrentProject(state),
  projectsLength: getProjectsLength(state),
  region: getRegion(state),
  oxygenMappings: getOxygenMappings(state),
  analyticsId: getAnalyticsId(state),
  analyticsHostingAppName: getAnalyticsHostingAppName(state),
  isPackageDeepLinking: getIsPackageDeepLinking(state),
});

export default connect(mapStateToProps, {
  fetchIssuesAction,
  fetchIssueInstanceAction,
  setPreviewIssueIdAction,
  showNewIssueModalAction,
  routeChangeEventTriggerAction,
  setCurrentViewAction,
  fetchCurrentUserAction,
  fetchCurrentDocsProjectAction,
  setAnalyticsId,
  registerAnalyticsMandatorySuperProps,
  setAnalyticsPeopleProps,
  setAnalyticsMandatoryPeopleProps,
  setQueryParamsFromUrlAction,
  setPackageDeepLinkingFalse,
})(Routes);

